import { Field } from "formik";
import { Autocomplete } from "formik-mui";
import * as Yup from "yup";
import { useMemo } from "react";
import MuiTextField from "@mui/material/TextField";
import config from "@poseidon/utils/config";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { useVulnerabilityNotesLog } from "../../hooks/useVulnerabilityNotesLog";
import * as api from "../../api";
import NoteLog from "../../../NoteLog/NoteLog";
import { Panel } from "@poseidon/ui/components";
import { EditSailorRiskProfileFormPanel } from "../riskProfile/EditSailorRiskProfileFormPanel";

const vulnerabilities = [
  "Hearing impairment",
  "Visual impairment",
  "Learning difficulties",
  "Poor English",
  "Poor Digital Skills",
  "Poor literacy",
  "Poor numeracy",
];

const sailorDefaults = {};

export const validationSchema = Yup.object().shape({
  //todo: validation
});

export function VulnerabilityNotes({ sailor }) {
  const { noteCategories } = config;
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const { vulnerabilityNotesLog } = useVulnerabilityNotesLog(sailor.id);

  const onVulnerabilityNotesAddHandler = (values, { resetForm }) => {
    try {
      api.addNote({
        ...values,
        sailor,
        noteCategory: noteCategories.vulnerabilityNote,
      });
      resetForm();
      setToast("Added Note");
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <Panel
      title="Vulnerability Notes"
      collapsedDetail={`${vulnerabilityNotesLog.length} notes`}
      expandable
      startCollapsed
    >
      <NoteLog
        log={vulnerabilityNotesLog}
        onSubmitHandler={onVulnerabilityNotesAddHandler}
      />
    </Panel>
  );
}
export function VulnerabilityFields({ sailor, riskProfile, readonly }) {
  const initialValues = useMemo(
    () => ({
      ...sailorDefaults,
      ...riskProfile,
    }),
    [riskProfile]
  );
  return (
    <EditSailorRiskProfileFormPanel
      title="Observed Vulnerabilities"
      disabled={readonly}
      initialValues={initialValues}
      // mapValues={mapValues}
      validationSchema={validationSchema}
      sailor={sailor}
    >
      <Field
        name="vulnerabilities"
        multiple
        freeSolo
        component={Autocomplete}
        options={vulnerabilities}
        // getOptionLabel={(option) => option.title}
        style={{ width: "100%" }}
        renderInput={(params) => (
          <MuiTextField
            {...params}
            name="vulnerabilities"
            // error={touched["vulnerabilities"] && !!errors["vulnerabilities"]}
            // helperText={touched["vulnerabilities"] && errors["vulnerabilities"]}
            label="Vulnerabilities"
            variant="outlined"
          />
        )}
      />
    </EditSailorRiskProfileFormPanel>
  );
}
